import EntityCrudPage from '../shared/EntityCrudPage';
import { assetRegisterConfig } from '../config/entityConfigs';

const ItAssetRegisterPage = () => <EntityCrudPage config={assetRegisterConfig} />;

export default ItAssetRegisterPage;
